module.exports = __webpack_public_path__ + "220cb9d8a65d0a135c73dd4710c31d42.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/success-dongzishaokao.png
// module id = 213
// module chunks = 1